import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { ProjectModalContainerDesktop, ProjectModalContainerMobile } from './containers';
import { IProjectModalContainerBaseProps } from './types';

export type IProjectModalContainerProps = IProjectModalContainerBaseProps;

export const ProjectModalContainer: React.FC<IProjectModalContainerProps> = ({
  onClose,
  onPhoneButtonClick,
  ...project
}: IProjectModalContainerProps) => {
  const deviceType = useDeviceType();

  const ProjectModal = deviceType === 'desktop' ? ProjectModalContainerDesktop : ProjectModalContainerMobile;

  return <ProjectModal {...project} onClose={onClose} onPhoneButtonClick={onPhoneButtonClick} />;
};
